import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const portalApi = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

portalApi.interceptors.request.use((config) => {
  const token = localStorage.getItem('cliente_portal_token');
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

portalApi.interceptors.response.use(
  (r) => r,
  (error) => {
    if (error?.response?.status === 401) {
      localStorage.removeItem('cliente_portal_token');
      localStorage.removeItem('cliente_portal_user');
      if (!window.location.pathname.startsWith('/oficina/cliente')) {
        window.location.href = '/oficina/cliente';
      }
    }
    return Promise.reject(error);
  }
);

export default portalApi;
